const ccVerification = {
    showNotice: false,
    scenario: 1,
    last4: '',
    transactionType: '',
    busy: false,
    showVerify: false
};

export default ccVerification;